var React = require('react');

function ChevronRight12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=12x12, Inverted=off"},React.createElement("path",{"id":"Vector","d":"M3.5 11l5-4.5v-1L3.5 1","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round"})));
}

ChevronRight12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ChevronRight12x12;

ChevronRight12x12.default = ChevronRight12x12;
